import { WorkspaceLimitRow, type WorkspaceLimitItem } from './workspace-limit-row';

export interface WorkspaceLimitSection {
  title: string;
  description: string;
  items: WorkspaceLimitItem[];
}

interface WorkspaceLimitSectionCardProps {
  section: WorkspaceLimitSection;
  loading?: boolean;
}

export function WorkspaceLimitSectionCard({
  section,
  loading = false,
}: WorkspaceLimitSectionCardProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-muted-foreground text-sm">{section.title}</h3>
      </div>
      <div className="bg-sidebar-background flex flex-col divide-y rounded-2xl px-4 py-2">
        {section.items.map((item) => (
          <WorkspaceLimitRow key={item.label} item={item} loading={loading} />
        ))}
      </div>
    </div>
  );
}
